import cookie from './cookie';

/**
 * 设置主题 true: 暗色 false: 浅色
 * @param {Boolean} _isDarkOn 
 */
const switchDarkOn = (_isDarkOn) => {
  if(_isDarkOn === undefined || typeof _isDarkOn !== 'boolean') return;
  let _curTheme = cookie.getCookie('is_dark_theme_on') == 1 ? true : false; 
  let _isAutoTheme = cookie.getCookie('is_auto_theme_on') == 1 ? true : false;
  if(_isDarkOn === _curTheme && !_isAutoTheme) return;
 
  if(_isDarkOn) {
    cookie.setCookie('is_dark_theme_on', "1")
  } else {
    cookie.setCookie('is_dark_theme_on', "0")
  }
}
const setAutoTheme=()=>{
  let theme = systemTheme();
  switch (theme) {
    case 1:
      return switchDarkOn(true)
    case 2:
      return switchDarkOn(false)
    default:
      return switchDarkOn(false)
  }
}

/**
 * 判断系统主题
 * @returns 0 浏览器不支持外观主题跟随系统 1 深色 2 浅色
 */
const systemTheme = ()=>{
  if (window.matchMedia('(prefers-color-scheme)')&&window.matchMedia('(prefers-color-scheme)').media === 'not all') {
    return 0
  }
  if(window.matchMedia('(prefers-color-scheme)')&&window.matchMedia('(prefers-color-scheme: dark)').matches){
    return 1
  }
  return 2
}
/**
 * 是否设置切换系统主题， true: 是，false: 否
 * @param {boolean} _autoThemeIsOn 
 */
const switchAutoTheme = (_autoThemeIsOn) => {
  if(_autoThemeIsOn === undefined || typeof _autoThemeIsOn !== 'boolean') return;
  let _curTheme = cookie.getCookie('is_auto_theme_on') == 1 ? true : false; 
  if(_autoThemeIsOn === _curTheme) return;
  if(_autoThemeIsOn) {
    cookie.setCookie('is_auto_theme_on', "1")
    setAutoTheme()
  } else {
    cookie.setCookie('is_auto_theme_on', "0")
  }
}
export {
  switchAutoTheme,
  switchDarkOn,
  systemTheme,
  setAutoTheme
}


// WEBPACK FOOTER //
// ./src/common/theme.js